import { formatToHumanReadable } from "@/lib/format-data";

import { ToolCallSummary } from "@/types/call";

/** Human-friendly label for an assistant tool name. Shared by the chat
 * message tool-result chip and the call transcript so both surfaces name
 * actions identically. */
export function friendlyToolName(toolName: string): string {
  switch (toolName) {
    case "CreateAppointment":
      return "Created Appointment";
    case "ConfirmAppointment":
      return "Confirmed Appointment";
    case "CancelAppointment":
      return "Cancelled Appointment";
    case "RescheduleAppointment":
      return "Rescheduled Appointment";
    case "FindAvailability":
      return "Searched Availability";
    case "ListProvidersAndServices":
      return "Looked Up Providers & Services";
    case "SearchClinicKnowledge":
      return "Searched Clinic Wiki";
    case "NotifyStaff":
      return "Notified Staff";
    case "UpdatePatient":
      return "Updated Patient Info";
    case "NoResponse":
      return "No Response Needed";
    default:
      return formatToHumanReadable(toolName);
  }
}

/** Pull a human-readable message out of a tool result, if present. */
export function formatToolResultMessage(
  result: Record<string, unknown> | null,
): string | null {
  const value = result?.message;
  if (value === null || value === undefined) return null;
  if (typeof value === "string") return value;
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "number") return String(value);
  return null;
}

export type ToolCallStatus = "success" | "failed" | "unknown";

export function classifyToolCall(toolCall: ToolCallSummary): ToolCallStatus {
  if (toolCall.result?.success === true) return "success";
  if (toolCall.result?.success === false) return "failed";
  return "unknown";
}

export function statusIconColor(status: ToolCallStatus): string {
  if (status === "failed") return "text-status-error-text";
  if (status === "unknown") return "text-foreground-muted";
  return "text-status-warning-text";
}
